// Vue
import { ref } from "vue";

// Dependencies
import { defineStore } from "pinia";

// Types
import { DefaultModelsType } from "./../types/DefaultModelsType";

// GraphQL
import { GetModelsQuery } from "@/graphql";

interface DefaultModelsProvider {
  // Getters
  getDefaultModels: () => DefaultModelsType;

  // Methods
  mapData: (data: GetModelsQuery) => void;

  // Utility
  getLoading: () => boolean;
  setLoading: (newValue: boolean) => void;
}

const useDefaultModels = defineStore("DefaultModelsProvider", (): DefaultModelsProvider => {
  // ///////////////////
  // Refs
  // ///////////////////

  const defaultModels = ref<DefaultModelsType>([]);

  // ///////////////////
  // Getters
  // ///////////////////

  function getDefaultModels() {
    return defaultModels.value;
  }

  // ///////////////////
  // Setters
  // ///////////////////

  function setDefaultModels(newModels: DefaultModelsType) {
    defaultModels.value = newModels;
  }

  // ///////////////////
  // Methods
  // ///////////////////

  function mapData(data: GetModelsQuery) {
    const { model } = data;

    // Map all models
    if (!model) return;
    setDefaultModels(model);
  }

  // ///////////////////
  // Utility
  // ///////////////////

  const loading = ref<boolean>(false);

  function setLoading(newValue: boolean) {
    loading.value = newValue;
  }

  function getLoading() {
    return loading.value;
  }

  // ///////////////////
  // Returns
  // ///////////////////

  return {
    // Getters
    getDefaultModels,

    // Methods
    mapData,

    // Utility
    getLoading,
    setLoading,
  };
});

export default useDefaultModels;
